export default ({ savedItems: { sortOrder, indicatives } }) =>
  indicatives.sortOrder || sortOrder;
